import PaymentForm from "../components/PaymentForm";
import InnerBanner from "../presentation/InnerBanner";
import SEO from "../global/SEO";

const Payment = () => (
  <>
    <SEO 
      title="Secure Payment | LiveAssignment.com - Safe & Easy Payment Options"
      description="Make secure payments for your assignment help. Multiple payment options available including credit cards, PayPal, and bank transfers. 100% secure transactions."
      keywords="assignment payment, secure payment, online payment, assignment help payment, academic payment, safe payment options"
      h1Heading="Secure Payment for Assignment Help Services"
      canonicalUrl="https://liveassignment.com/payment"
    />
    <InnerBanner pageTitle="Payment"></InnerBanner>
    <PaymentForm />
  </>
);

export default Payment;
